import validator from "validator";

const patternPwd =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/;

export const loginValidation = (data) => {
  const errors = {};
  console.log(data);

  const contact = data?.contact ? data.contact.trim() : "";
  // const password = data?.password ? data.password.trim() : "";
  const pin = data?.pin ? data.pin.trim() : "";

  // Validate contact
  if (!contact) {
    errors.contact = "Please enter mobile number";
  } else if (!/^(?:\+237|\d{3})\d{8,9}$/.test(contact)) {
    // Updated regex
    errors.contact =
      "Please enter a valid mobile number with country code (+237) or without it, and with 8 or 9 digits";
  }
  // else if (!/^(?:\+237|\d{3})\d{9}$/.test(contact)) { // Updated regex
  //   errors.contact = "Please enter a valid mobile number with country code (+237) or without it";
  // }
  // else if (!validator.isMobilePhone(contact, "any", { strictMode: false })) {
  //   errors.contact = "Please enter a valid mobile number";
  // }

  if (!pin) {
    errors.pin = "Please enter your PIN";
  } else if (!/^\d{4}$/.test(pin)) {
    errors.pin = "PIN must be exactly 4 digits";
  }

  return { errors, isValid: Object.keys(errors).length == 0 };
};

export const signupValidation = (data) => {
  let errors = {};

  if (validator.isEmpty(data?.contact?.trim())) {
    errors.contact = "Please enter mobile number";
  }

  const pin = data?.pin?.trim();
  if (!pin) {
    errors.pin = "Please enter PIN";
  } else if (!/^\d{4}$/.test(pin)) {
    errors.pin = "PIN must be exactly 4 digits";
  }

  return { errors, isValid: Object.keys(errors).length <= 0 };
};

export const signupPwdValidation = (data) => {
  let errors = {};
  if (validator.isEmpty(data?.email.trim()))
    errors.email = "Please enter email address";
  else if (!validator.isEmail(data?.email.trim()))
    errors.email = "Please enter a valid email address";

  if (validator.isEmpty(data?.password1.trim()))
    errors.password1 = "Please enter password";
  else if (!patternPwd.test(data?.password1))
    errors.password1 =
      "Password should be at least 8 characters with upper case, number and special character";

  if (data?.password1 !== data?.password2) {
    errors.password2 = "Both password should be same.";
  }

  return { errors, isValid: Object.keys(errors).length <= 0 };
};

export const forgotPasswordValidation = (data) => {
  let errors = {};

  if (validator.isEmpty(data?.oldPassword.trim()))
    errors.oldPassword = "Please enter password";
  else if (!patternPwd.test(data?.oldPassword))
    errors.oldPassword =
      "Old Password should be at least 8 characters with upper case, number and special character";

  if (validator.isEmpty(data?.newPassword.trim()))
    errors.newPassword = "Please enter password";
  else if (!patternPwd.test(data?.newPassword))
    errors.newPassword =
      "New Password should be at least 8 characters with upper case, number and special character";

  if (data.oldPassword == data.newPassword) {
    errors.newPassword = "Old Password and New Password should not be same.";
  }

  return { errors, isValid: Object.keys(errors).length <= 0 };
};

export const forgetPasswordValidation = (data) => {
  let errors = {};
  const contact = data?.contact ? data.contact.trim() : "";
  if (!contact) {
    errors.contact = "Please enter mobile number";
  } else if (!validator.isMobilePhone(contact, "any", { strictMode: false })) {
    errors.contact = "Please enter a valid mobile number";
  }

  return { errors, isValid: Object.keys(errors).length <= 0 };
};

export const resetPasswordValidation = (data) => {
  let errors = {};
  if (validator.isEmpty(data?.password?.trim()))
    errors.password = "Please enter new password";

  if (!validator.isEmpty(data?.password?.trim()) && data?.password?.length < 6)
    errors.password = "Password must be at least 6 characters";

  return { errors, isValid: Object.keys(errors).length <= 0 };
};

export const changePinValidation = (values) => {
  let errors = {};

  if (!values.old_pin) {
    errors.old_pin = "Old PIN is required";
  } else if (values.old_pin.length < 4) {
    errors.old_pin = "Old PIN must be at least 4 digits";
  }

  if (!values.new_pin) {
    errors.new_pin = "New PIN is required";
  } else if (values.new_pin.length < 4) {
    errors.new_pin = "New PIN must be at least 4 digits";
  }

  if (!values.confirm_pin) {
    errors.confirm_pin = "Confirm PIN is required";
  } else if (values.confirm_pin !== values.new_pin) {
    errors.confirm_pin = "Confirm PIN does not match new PIN";
  }

  return {
    errors,
    isValid: Object.keys(errors).length == 0,
  };
};
